import { render, staticRenderFns } from "./TableRecievables.vue?vue&type=template&id=7359bc2c&scoped=true"
import script from "./TableRecievables.vue?vue&type=script&lang=js"
export * from "./TableRecievables.vue?vue&type=script&lang=js"
import style0 from "./TableRecievables.vue?vue&type=style&index=0&id=7359bc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359bc2c",
  null
  
)

export default component.exports